export function publish(eventName, payload) {
    const event = payload !== undefined
        ? new CustomEvent(eventName, { detail: payload })
        : new CustomEvent(eventName);
    window.dispatchEvent(event);
}



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/emitter-subscriber/publish.js
// module id = ./node_modules/@celine/passive-tracking/dist/emitter-subscriber/publish.js
// module chunks = 0